var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutOfService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.004,
    height: 14,
    viewBox: "0 0 16.004 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-danger-6081930",
    d: "M93.912,146.04l-6.469-10.993a1.517,1.517,0,0,0-.8-.661,1.552,1.552,0,0,0-1.046,0,1.517,1.517,0,0,0-.8.661L78.328,146.04a1.472,1.472,0,0,0-.188,1.013,1.49,1.49,0,0,0,.523.892,1.545,1.545,0,0,0,.987.35H92.589a1.545,1.545,0,0,0,.987-.35,1.49,1.49,0,0,0,.523-.892,1.472,1.472,0,0,0-.188-1.013Zm-7.792.713a.95.95,0,0,1-.666-.269.909.909,0,0,1,0-1.3.954.954,0,0,1,1.331,0,.911.911,0,0,1,0,1.3A.947.947,0,0,1,86.12,146.753Zm.725-3.588a.714.714,0,0,1-.388.526.74.74,0,0,1-.662,0,.714.714,0,0,1-.388-.526l-.371-4.242a1.053,1.053,0,0,1,.288-.8,1.1,1.1,0,0,1,1.592,0,1.053,1.053,0,0,1,.288.8Z",
    transform: "translate(-78.118 -134.295)",
    fill: "#ffec00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfService);
export default __webpack_public_path__ + "static/media/outOfService.e122853c3762e1c8d2bdd14dbe7d3de9.svg";
export { ForwardRef as ReactComponent };